import * as React from "react";
function SvgIcStartOn(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 3.803a1 1 0 011.555-.832L9.35 6.168a1 1 0 010 1.664L4.555 11.03A1 1 0 013 10.197V3.803z" stroke="currentColor" /></svg>;
}
export default SvgIcStartOn;